<div class="apps-book-widget-mobile-skeleton">
  <div class="apps-book-widget-mobile-skeleton__row-1">
    <div
      class="apps-book-widget-mobile-skeleton__row-1__container"
      *ngFor="let i of [1, 2, 3, 4]"
    >
      <mach-skeleton-loader
        [shape]="'headline'"
        class="apps-book-widget-mobile-skeleton__row-1__container__line"
      ></mach-skeleton-loader>
    </div>
  </div>

  <div class="apps-book-widget-mobile-skeleton__row-2">
    <div
      class="apps-book-widget-mobile-skeleton__row-2__container"
      *ngFor="let i of [1, 2, 3, 4]"
    >
      <mach-skeleton-loader
        [shape]="'headline'"
        class="apps-book-widget-mobile-skeleton__row-2__container__label"
      ></mach-skeleton-loader>
      <mach-skeleton-loader
        [shape]="'headline'"
        class="apps-book-widget-mobile-skeleton__row-2__container__toggle"
      ></mach-skeleton-loader>
    </div>
  </div>

  <div class="apps-book-widget-mobile-skeleton__row-3">
    <div class="apps-book-widget-mobile-skeleton__row-3__container">
      <mach-skeleton-loader
        [shape]="'headline'"
        class="apps-book-widget-mobile-skeleton__row-3__container__label"
      ></mach-skeleton-loader>
      <mach-skeleton-loader
        [shape]="'headline'"
        class="apps-book-widget-mobile-skeleton__row-3__container__checkbox"
      ></mach-skeleton-loader>
    </div>
  </div>

  <div class="apps-book-widget-mobile-skeleton__row-4">
    <div class="apps-book-widget-mobile-skeleton__row-4__container">
      <mach-skeleton-loader
        [shape]="'button'"
        class="apps-book-widget-mobile-skeleton__row-4__container__button"
      ></mach-skeleton-loader>
    </div>
  </div>
</div>
